import { DocumentTemplateTypes } from '../../constants';
import {
	FooterNextButtonAnalyticsIds,
	FooterPreviousButtonAnalyticsIds,
	TemplateSelectionCardAnalyticsIds,
} from './events';

export const getAnalyticsIdForFooter = (currentStep: number, button: string) => {
	if (currentStep === 0) {
		return FooterNextButtonAnalyticsIds.StartPage;
	} else if (currentStep === 1) {
		return button === 'next'
			? FooterNextButtonAnalyticsIds.PreparePage
			: FooterPreviousButtonAnalyticsIds.PreparePage;
	} else if (currentStep === 2) {
		return button === 'next'
			? FooterNextButtonAnalyticsIds.ReviewPageSaveTemplate
			: FooterPreviousButtonAnalyticsIds.ReviewPage;
	}
};

export const getAnalyticsIdForTemplateCard = (templateName: string) => {
	const analyticsIdMap: Record<string, string> = {
		[DocumentTemplateTypes.Static.name]: TemplateSelectionCardAnalyticsIds.Static,
		[DocumentTemplateTypes.Dynamic.name]: TemplateSelectionCardAnalyticsIds.Dynamic,
	};

	return analyticsIdMap[templateName] || '';
};
